const DEEPSEEK_API_KEY = 'sk-5adea288eee542c89c698c5dc29bc697';
const DEEPSEEK_API_URL = 'https://api.deepseek.com/v1/chat/completions';

export interface ProjectContext {
  projectTitle: string;
  businessIdea: string;
  targetAudience: string;
  features: {
    description: string;
    priority: 'must-have' | 'nice-to-have';
    completed: boolean;
  }[];
  timeline: string;
  estimatedCost: string;
  successMetrics: string[];
}

export async function generateBoltPrompt(context: ProjectContext): Promise<string> {
  const systemPrompt = `Você é um especialista em desenvolvimento de software e está ajudando a criar um prompt para o bolt.diy gerar um MVP.
O bolt.diy é uma ferramenta que gera código completo a partir de prompts em linguagem natural.
Seu objetivo é criar um prompt detalhado que descreva o MVP de forma que o bolt.diy possa gerar o código corretamente.`;

  const userPrompt = `Por favor, crie um prompt para o bolt.diy gerar um MVP com as seguintes características:

Projeto: ${context.projectTitle}
Ideia de Negócio: ${context.businessIdea}
Público-Alvo: ${context.targetAudience}

Funcionalidades Principais:
${context.features.map(f => `- ${f.description} (${f.priority})`).join('\n')}

Tempo de Desenvolvimento: ${context.timeline}
Custo Estimado: ${context.estimatedCost}

Métricas de Sucesso:
${context.successMetrics.map(m => `- ${m}`).join('\n')}

O prompt deve:
1. Ser detalhado e específico
2. Incluir todas as funcionalidades listadas
3. Especificar tecnologias modernas e adequadas
4. Incluir boas práticas de desenvolvimento
5. Considerar aspectos de UI/UX
6. Incluir testes e documentação
7. Ser organizado em seções claras`;

  try {
    const response = await fetch('/api/ai/chat', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        messages: [
          { role: 'system', content: systemPrompt },
          { role: 'user', content: userPrompt }
        ],
        model: 'deepseek-chat',
        temperature: 0.7,
        max_tokens: 2000
      })
    });

    if (!response.ok) {
      throw new Error(`API request failed: ${response.status}`);
    }

    const data = await response.json();
    return data.choices[0].message.content;
  } catch (error) {
    console.error('Erro ao gerar prompt:', error);
    throw error;
  }
}

export async function analyzeJournal(content: string): Promise<string> {
  try {
    const response = await fetch('/api/ai/chat', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        messages: [
          {
            role: 'system',
            content: 'Você é um assistente pessoal motivador e empático. Analise o diário do usuário e forneça um comentário curto (máximo 3 parágrafos) com: 1) Um elogio específico sobre algo positivo, 2) Uma sugestão construtiva para melhoria, 3) Uma frase motivacional personalizada.'
          },
          {
            role: 'user',
            content
          }
        ],
        model: 'deepseek-chat',
        temperature: 0.7,
        max_tokens: 500
      })
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data.choices[0].message.content;
  } catch (error) {
    console.error('Error calling Deepseek API:', error);
    throw error;
  }
}
